import { LS } from '../../utils/lang';
// OpenAI TTS voice catalogue (server validates too). `es: true` marks voices
// that render especially naturally in Spanish narration.
export const OPENAI_VOICES = [
  { id: 'nova', label: LS('Nova — warm & clear', 'Nova — cálida y clara'), es: true },
  { id: 'coral', label: LS('Coral — warm & expressive', 'Coral — cálida y expresiva'), es: true },
  { id: 'shimmer', label: LS('Shimmer — bright', 'Shimmer — brillante'), es: true },
  { id: 'sage', label: LS('Sage — measured', 'Sage — pausada'), es: true },
  { id: 'ash', label: LS('Ash — soft & gentle', 'Ash — suave y amable'), es: true },
  { id: 'alloy', label: LS('Alloy — neutral', 'Alloy — neutral') },
  { id: 'echo', label: LS('Echo — calm', 'Echo — tranquila') },
  { id: 'fable', label: LS('Fable — storyteller', 'Fable — narradora') },
  { id: 'onyx', label: LS('Onyx — deep & authoritative', 'Onyx — profunda y firme') },
];

// Default premium voice per narration language.
export const DEFAULT_OPENAI_VOICE = { en: 'nova', es: 'coral' };

// Spanish translation codes — drives voice-language preference.
export const SPANISH_TRANSLATIONS = [
  'RVR1909', 'RVG', 'ONBV', 'ESS', 'PDPT', 'BLM', 'VBL', 'RV1865', 'TA', 'BLL', 'JUN', 'RV1602', 'RV1569',
  'RVR1960', 'NVI', 'TLA', 'LBLA', 'BSO', 'DHH', 'PDT', 'NTV',
  'CST', 'BTX', 'JBS', 'BLP', "RV1909+Strong's",
];

// Playback rate presets for the Speed select.
export const RATE_OPTIONS = [
  { value: '0.75', label: '0.75x' },
  { value: '0.85', label: LS('0.85x (Bedtime)', '0.85x (Para dormir)') },
  { value: '1', label: '1x' },
  { value: '1.25', label: '1.25x' },
  { value: '1.5', label: '1.5x' },
];
